import React from "react";
import Breadcrumb from "components/dashboard/home/BreadCrumb";
import profile from "../../../../assets/images/userIcon.JPG.jpg";
import emailIcon from "../../../../assets/images/emailIcon.svg";
import phoneIcon from "../../../../assets/images/phoneIcon.svg";
import passwordIcon from "../../../../assets/images/passwordIcon.svg";
import uploadIcon from "../../../../assets/images/upload.svg";
import Input from "components/dashboard/forms/Input";
import { profileSchema } from "components/dashboard/forms/courseSchema";
import { ProfileSettingSchema } from "components/dashboard/forms/ProfileSchema";
import { useNavigate } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import Button from "components/dashboard/forms/button/Button";
import { useFormik } from "formik";

const Settings = () => {
  const roles = JSON.parse(sessionStorage.getItem("#roles") || "{}");
  const navigate = useNavigate();
  const [endpoint, setApiEndpoint] = useState("");
  const [bgColor, setBgColor] = useState("");
  const [color, setColor] = useState("");
  const [lightBg, setLightBg] = useState("");
  const [textColor, setTextColor] = useState("");

  useEffect(() => {
    if (roles) {
      if (roles === "student") {
        setBgColor("bg-primary");
        setColor("primary");
        setTextColor("text-blueColor");
        setLightBg("bg-[#FEFEDE]");
        setApiEndpoint("/student-dashboard-endpoint");
      } else if (roles === "teacher") {
        setBgColor("bg-blueColor");
        setColor("blueColor");
        setTextColor("text-primary");
        setLightBg("bg-[#CCCFFF]");
        setApiEndpoint("/teacher-dashboard-endpoint");
      } else if (roles === "guest") {
        setColor("greenColor");
        setTextColor("text-primary");
        setLightBg("bg-[#CCCFFF]");
        setApiEndpoint("/guest-dashboard-endpoint");
      }
    }
  }, [roles, navigate]);
  const roleStyles = {
    student: {
      "--radio-inner-color": "#FFD600",
      "--radio-border-color-checked": "#FFD600",
    },
    teacher: {
      "--radio-inner-color": "#00296B",
      "--radio-border-color-checked": "#00296B",
    },
  };

  const user = JSON.parse(window.sessionStorage.getItem("auth"));
  console.log("settings data", user);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const fileInputRef = useRef(null);
  const [selectedValue, setSelectedValue] = useState("useImage");
  // const [formValues, setFormValues] = useState({
  //   firstName: user.firstName || "",
  //   lastName: user.firstName || "",
  //   email: user.email || "",
  //   phone: user.phone || ""
  // })

  const handleInputChange = (event) => {
    setSelectedValue(event.target.value);
    if (event.target.value === "useImage") {
      setSelectedAvatar(null); // Reset avatar when image is selected
    }
  };

  // const handleInputChanges = (e) => {
  //   const { name, value } = e.target;
  //   setFormValues({ ...formValues, [name]: value });
  // };

  // Handle avatar selection
  const handleAvatarSelect = (avatarUrl) => {
    setSelectedAvatar(avatarUrl);
    setSelectedImage(null); // Clear uploaded image when avatar is selected
  };
  const initialValues = {
    name: "",
    password: "",
    confirmPassword: "",
    email: "",
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema: ProfileSettingSchema,
    onSubmit: async (values, actions) => {
      console.log("Submitted values:", values);
      resetForm();
    },
  });
  const avatarUrls = [
    "https://robohash.org/1.png?set=set1",
    "https://robohash.org/2.png?set=set1",
    "https://robohash.org/3.png?set=set1",
    "https://robohash.org/4.png?set=set1",
    "https://robohash.org/5.png?set=set1",
  ];

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleUploadClick = () => {
    setSelectedAvatar(null);
    fileInputRef.current.click();
  };
  // const [formData, setFormData] = useState({
  //   currentPassword: values.currentPassword,
  //   password: values.password,
  //   confirmPassword: "",
  // });
  // console.log(formData)

  return (
    <div className="p-6 bg-gray-100 flex-1 overflow-auto">
      <Breadcrumb
        title={"Profile Settings"}
        bgColor={bgColor}
        textColor={textColor}
      />
      <div className="w-full bg-white rounded-lg p-6 my-8 overflow-hidden flex flex-col gap-6 ">
        <div className="flex flex-col gap-6">
          <h2 className=" text-[18px]  font-ManropeSemibold">Profile Photo</h2>
          <div className="flex gap-6 items-center">
            <div className=" ">
              {selectedValue === "useImage" && selectedImage ? (
                <img
                  src={selectedImage}
                  alt="profile-image"
                  className="w-[6.3rem] h-[6.3rem] rounded-full"
                />
              ) : selectedValue === "useAvatar" && selectedAvatar ? (
                <img
                  src={selectedAvatar}
                  alt="profile-image"
                  className="w-[6.3rem] h-[6.3rem] rounded-full"
                />
              ) : (
                <img
                  src={profile}
                  alt="profile-image"
                  className="w-[6.3rem] h-[6.3rem] rounded-full"
                />
              )}
            </div>
            <div class="radio-group" style={roleStyles[roles]}>
              <label class="radio-container" style={roleStyles[roles]}>
                <input
                  type="radio"
                  name="radio"
                  value="useAvatar"
                  onChange={handleInputChange}
                  checked={selectedValue === "useAvatar"}
                />
                <span class="custom-radio"></span>
                Use Avatar
              </label>
              <label class="radio-container" style={roleStyles[roles]}>
                <input
                  type="radio"
                  name="radio"
                  value="useImage"
                  onChange={handleInputChange}
                  checked={selectedValue === "useImage"}
                />
                <span class="custom-radio" style={roleStyles[roles]}></span>
                Use Image
              </label>
            </div>
            {/* Avatar Selection */}
            {selectedValue === "useAvatar" && (
              <div className="flex flex-wrap gap-4">
                {avatarUrls.map((avatarUrl, index) => (
                  <button
                    key={index}
                    onClick={() => handleAvatarSelect(avatarUrl)}
                    className={`border-2 ${
                      selectedAvatar === avatarUrl
                        ? "border-blue-500"
                        : "border-gray-300"
                    } rounded-full p-1`}
                  >
                    <img
                      src={avatarUrl}
                      alt={`Avatar ${index + 1}`}
                      className="w-16 h-16 rounded-full"
                    />
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="flex gap-6">
            <Button
              className={`text-blueColor items-center flex gap-2 ${lightBg} font-ManropeSemibold px-4 rounded-md`}
              onClick={handleUploadClick}
            >
              <img src={uploadIcon} alt="upload-icon" /> Upload Image
            </Button>
            <input
              type="file"
              ref={fileInputRef}
              accept="image/*"
              onChange={handleImageChange}
              className="input-file hidden"
            />
            <Button>Save changes</Button>
          </div>
        </div>
        <main className="flex md:flex-row flex-col gap-6">
          <section className="flex flex-col gap-6 w-full">
            <h2 className="text-[#1A1A1A] md:text-[18px] font-medium font-ManropeSemibold leading-[24px]">
              Personal Information
            </h2>
            <div className="w-full">
              <Input
                label={profileSchema.firstName.label}
                type={profileSchema.firstName.type}
                name={"firstName"}
                placeholder={""}
                style={{ paddingLeft: "20px" }}
                // value={formValues.firstName}
                // onChange={handleInputChanges}
              />
              <Input
                label={profileSchema.lastName.label}
                type={profileSchema.lastName.type}
                name={"lastName"}
                placeholder={""}
                style={{ paddingLeft: "20px" }}
                // value={formValues.lastName}
                // onChange={handleInputChanges}
              />
              <Input
                label={profileSchema.emailAddress.label}
                type={profileSchema.emailAddress.type}
                name={"email"}
                placeholder={""}
                icon={<img src={emailIcon} alt="email" />}
                // value={formValues.email}
                // onChange={handleInputChanges}
              />
              <Input
                label={profileSchema.phoneNumber.label}
                type={profileSchema.phoneNumber.type}
                name={"phone"}
                placeholder={""}
                icon={<img src={phoneIcon} alt="email" />}
                // value={formValues.phone}
                // onChange={handleInputChanges}
              />
            </div>
            <div className="w-fit">
              <Button>Save changes</Button>
            </div>
          </section>
          <form className="flex flex-col gap-6 w-full">
            <h2 className="text-[#1A1A1A] md:text-[18px]  font-ManropeSemibold leading-[24px]">
              Change Password
            </h2>
            <div className="w-full">
              <Input
                label={"Verify Current Password"}
                type={"password"}
                name={"currentPassword"}
                placeholder={""}
                icon={<img src={passwordIcon} alt="email" />}
                obscured
                value={values.currentPassword}
                onChange={handleChange}
                onBlur={handleBlur}
              />

              <div className="w-full">
                <Input
                  label={"New Password"}
                  type={"password"}
                  name={"password"}
                  placeholder={"Enter Password"}
                  icon={<img src={passwordIcon} alt="email" />}
                  obscured
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.password && touched.password && (
                  <div className="grid lg:grid-cols-2 grid-cols-1 items-center gap-2 mt-2">
                    {Array.isArray(errors.password) ? (
                      errors.password.map((err, index) => (
                        <div key={index} className="flex items-center gap-2">
                          <div className="w-[8px] h-[8px] rounded-full bg-[#0B7077]"></div>
                          <p className="text-[#000]">{err}</p>
                        </div>
                      ))
                    ) : (
                      <div className="flex items-center gap-2">
                        <div className="w-2 h-2 rounded-full bg-[#0B7077]"></div>
                        <p className="text-red-500">{errors.password}</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <Input
                label={"Comfirm Password"}
                type={"password"}
                name={"confirmPassword"}
                placeholder={"Enter Password"}
                icon={<img src={passwordIcon} alt="email" />}
                obscured
                value={values.confirmPassword}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {touched.confirmPassword && errors.confirmPassword && (
                <div className="flex items-center gap-2 mt-2">
                  <div className="w-2 h-2 rounded-full bg-[#0B7077]"></div>
                  <p className="text-red-500">{errors.confirmPassword}</p>
                </div>
              )}
            </div>
            <div className="w-fit">
              <Button onClick={handleSubmit}>Save changes</Button>
            </div>
          </form>
        </main>
      </div>
    </div>
  );
};

export default Settings;
